/**
 * LES JOURS DE L'ÉVÉNEMENT, À AFFICHER.
 *
 * Ce fichier portait la complétion de la reprise V1 (nom, période, lieu et pied de page
 * tirés de l'événement), retirée avec la reprise du panneau. Il n'en reste que le
 * formatage des jours, que le badge lit.
 */

/**
 * LES DEUX BORNES, dans la langue de référence ; une seule date quand l'événement tient
 * en un jour.
 *
 * ⚠️ MIDI UTC, ET C'EST UN PIÈGE CLASSIQUE. `new Date("2026-09-21")` est minuit UTC ;
 * affiché dans un fuseau à l'ouest, il recule d'un jour et l'événement se tient la
 * veille. On lit donc la date à midi, et on la formate en UTC.
 *
 * ⚠️ DEUX CHAÎNES, PAS UNE PHRASE. Le badge les écrit l'une sous l'autre (sa carte fait
 * 300 px, « 21 septembre 2020 – 22 septembre 2020 » s'y coupait en plein milieu du
 * second mois), et un mot de liaison serait à traduire.
 */
export function bornes(
  days: ReadonlyArray<string>,
  locale: string,
): ReadonlyArray<string> {
  const dates = days
    .map((day) => new Date(`${day}T12:00:00Z`))
    .filter((d) => !Number.isNaN(d.getTime()))
    .sort((a, b) => a.getTime() - b.getTime());

  const first = dates[0];
  const last = dates[dates.length - 1];
  if (!first || !last) return [];

  const options: Intl.DateTimeFormatOptions = {
    day: "numeric",
    month: "long",
    year: "numeric",
    timeZone: "UTC",
  };
  /* La langue vient de la base (« FR », « EN »…). `Intl` lève sur une étiquette
     qu'il ne sait pas lire, et le badge ne doit pas tomber sur le code d'une langue
     exotique : on retombe alors sur celle du navigateur. */
  let format: Intl.DateTimeFormat;
  try {
    format = new Intl.DateTimeFormat(locale, options);
  } catch {
    format = new Intl.DateTimeFormat(undefined, options);
  }

  return first.getTime() === last.getTime()
    ? [format.format(first)]
    : [format.format(first), format.format(last)];
}
